export const createGlassStyle = (currentColor: string) => ({
  backgroundColor: `${currentColor}CC`,
  backdropFilter: 'blur(12px) saturate(150%)',
  WebkitBackdropFilter: 'blur(12px) saturate(150%)',
});

export const createWaterDropStyle = () => ({
  backdropFilter: 'blur(10px)',
  WebkitBackdropFilter: 'blur(10px)',
  border: '2px solid rgba(255, 255, 255, 0.3)',
  boxShadow: `
    0 12px 40px 0 rgba(0, 0, 0, 0.3),
    inset 0 0 20px rgba(255, 255, 255, 0.2),
    0 0 0 1px rgba(255, 255, 255, 0.1)
  `,
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-50%',
    left: '-50%',
    width: '200%',
    height: '200%',
    background: 'radial-gradient(circle, rgba(255,255,255,0.05) 0%, transparent 50%)',
    transform: 'rotate(0deg)',
    animation: 'waterDrop 12s linear infinite',
  },
});

export const waterDropKeyframes = `
  @keyframes waterDrop {
    0% {
      transform: rotate(0deg);
      opacity: 0.3;
    }
    50% {
      opacity: 0.1;
    }
    100% {
      transform: rotate(360deg);
      opacity: 0.3;
    }
  }
`;

export const getContrastColor = (rgbColor: string): string => {
  try {
    if (!rgbColor) return 'black';

    const match = rgbColor.match(/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/);
    if (!match) return 'black';

    const [, r, g, b] = match.map(Number);
    if (isNaN(r) || isNaN(g) || isNaN(b)) return 'black';

    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 140 ? 'black' : 'white';
  } catch {
    return 'black';
  }
};
